import React, { useState, useEffect } from 'react'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import { IconButton, Stack } from '@mui/material'
import { uploadDocument } from '../../services/uploadDocument'
import CustomModal from '../../UI/CustomModal'

function UploadDocument({ idDocumento, disabled, onUpload, idPratica }) {
  //const [selectedDocument, setSelectedDocument] = useState()
  const [loading, setLoading] = useState(false)
  const [infoMessage, setInfoMessage] = useState('')
  const [isFileSelected, setIsFileSelected] = useState(false)
  const [selectedId, setSelectedId] = useState('')
  const [error, setError] = useState(false)

  const fileInputRef = React.useRef()


  const handleSelection = event => {
    event.preventDefault()
    setLoading(true)
    let document = event.target.files[0]
    //setSelectedDocument(document)
    setIsFileSelected(true)
    //setSelectedId(idDocumento)
    handleUpload(document)
  }


  const handleUpload = (selectedDocument) => {
    //if (selectedDocument !== undefined) {
    setInfoMessage('Upload documento in corso...')
    const file = new FormData()
    file.append('file', selectedDocument)
    uploadDocument(file, idDocumento, selectedDocument.name, idPratica)
      .then(response => {
        setLoading(false)
        setError(false)
        setInfoMessage(response.data.message)
        setTimeout(function() {
          onUpload(response.data.code)
          setInfoMessage('')
          setIsFileSelected(false)
        }, 4000)
      })
      .catch(error => {
        setError(true)
        setLoading(false)
        setError(true)
        setLoading(false)
debugger

        let errorMessage = 'Errore nell\'upload del file';

        if (error.response) {
          errorMessage = error.response.data?.message || errorMessage;
        } else if (error.code === 'ERR_NETWORK') {
          errorMessage = 'Errore di rete. Verifica il nome del file o la connessione.';
        } else {
          errorMessage = 'Si è verificato un errore imprevisto.';
        }

        setInfoMessage(errorMessage)
        setTimeout(function() {
          setIsFileSelected(false)
          setInfoMessage('')
        }, 3000)
      })/*.finally(() => {
          setSelectedDocument(undefined)
        });
    }*/
  }
  /*, [selectedDocument, isFileSelected, selectedId, onUpload])*/

  const handleIconClick = () => {
    fileInputRef.current.click()
  }

  return (
    <>
      <Stack direction="row" alignItems="center">
        <IconButton
          disabled={disabled}
          component="span"
          onClick={handleIconClick}
        >
          <input
            accept="application"
            hidden
            type="file"
            ref={fileInputRef}
            name="file"
            id={idDocumento}
            onClick={(event) => (event.target.value = null)}
            onChange={(e) => handleSelection(e)}
          />
          <CloudUploadIcon />
        </IconButton>
      </Stack>

      <CustomModal
        hideBackdrop
        open={isFileSelected}
        loading={loading}
        error={error}
        message={infoMessage}

      />
    </>
  )
}

export default UploadDocument
